import { BrButton } from '@govbr-ds/react-components';
import style from './headerAvatar.module.scss';
import { Avatar } from 'react-dsgov';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';

function HeaderAvatar({ name, image }: Readonly<{ name: string; image: string }>) {
  const navigate = useNavigate();
  const auth = useAuth();

  const [open, setOpen] = useState(false);

  const firstLetter = name.charAt(0);
  let avatarProps;
  if (image) {
    avatarProps = { imageSrc: image };
  } else if (name) {
    avatarProps = { letter: firstLetter, bgColor: 'bg-violet-50' };
  } else {
    avatarProps = { icon: 'fas fa-user' };
  }

  const dropDownClass = open ? 'fas fa-caret-up' : 'fas fa-caret-down';

  const logoutClick = () => {
    setOpen(false);
    navigate('/logout');
  };

  const loginClick = () => {
    setOpen(false);
    navigate('/login');
  };

  return (
    <div className={style.container}>
      <Avatar {...avatarProps} />
      <BrButton circle icon={dropDownClass} onClick={() => setOpen(!open)} />
      {auth.isAuthenticated && open && (
        <div className={style.dropdownContainer}>
          <div className={style.text}>
            Você está logado como <strong>{name}</strong>
          </div>
          <BrButton size='small' primary onClick={() => logoutClick()}>
            Logout
          </BrButton>
        </div>
      )}
      {auth.isAuthenticated === false && open && (
        <div className={style.dropdownContainer}>
          <BrButton size='small' primary onClick={() => loginClick()}>
            <span className='fas fa-user'></span> Entrar
          </BrButton>
        </div>
      )}
    </div>
  );
}

export default HeaderAvatar;
